var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control"},[_c('b-switch',{attrs:{"value":_vm.localValue},on:{"input":function($event){return _vm.updateValue($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }